<template>
  <div class="seth-set bg-primary">
    <div class="absolute top-0 py-10 w-full px-6 flex">
      <div>
        <p
          @click="handleback('controlCenter')"
          class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
        >
          <feather-icon
            class="flex"
            icon="ArrowLeftIcon"
            svgClasses="w-6 h-6"
          />
          Go Back
        </p>
        <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
          Version
        </h2>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    handleback(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
